import { useMutation } from '@tanstack/react-query'
import { relatoriosService } from '../services/relatorios.service'

export function useRelatorioResultadoIndividual() {
  return useMutation({
    mutationFn: (idinscricao: number) => relatoriosService.resultadoIndividual(idinscricao),
  })
}

export function useRelatorioRankingGeral() {
  return useMutation({
    mutationFn: (params: { idcampeonato: number; idmodalidade?: number }) =>
      relatoriosService.rankingGeral(params.idcampeonato, params.idmodalidade),
  })
}

export function useRelatorioMedalhas() {
  return useMutation({
    mutationFn: (params: { idcampeonato: number; top: number; idmodalidade?: number; idetapa?: number }) =>
      relatoriosService.medalhas(params.idcampeonato, params.top, params.idmodalidade, params.idetapa),
  })
}

export function useRelatorioParticipantes() {
  return useMutation({
    mutationFn: (params: { idcampeonato: number; idmodalidade?: number }) =>
      relatoriosService.participantes(params.idcampeonato, params.idmodalidade),
  })
}
